<div
	[formGroup]="form"
	gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
	gdGap="10px"
>
	<mat-form-field>
		<input
			matInput
			formControlName="searchText"
			placeholder="Search"
			autocomplete="off"
		/>
		<mat-icon matSuffix>search</mat-icon>
	</mat-form-field>
	<mat-form-field>
		<input
			matInput
			[readonly]="!this.form.get('startDate').value"
			formControlName="startDate"
			(click)="startDatePicker.open()"
			(keyup)="onKeyUpStartDate($event.key)"
			[matDatepicker]="startDatePicker"
			autocomplete="off"
			placeholder="Start date"
		/>
		<mat-hint>Filter jobs after start date</mat-hint>
		<mat-datepicker-toggle
			#startToggle
			matSuffix
			[for]="startDatePicker"
		></mat-datepicker-toggle>
		<mat-datepicker #startDatePicker></mat-datepicker>
	</mat-form-field>
	<rpshared-customer-id formControlName="customerId"> </rpshared-customer-id>
	<rpshared-field-team-id formControlName="teamId"></rpshared-field-team-id>
	<mat-form-field>
		<mat-label>Quote Status</mat-label>
		<mat-select disableOptionCentering="true" formControlName="quoteStatus">
			<mat-option>--</mat-option>
			<mat-option *ngFor="let status of quoteStatuses" [value]="status">
				{{ displayQuoteStatus[status] }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<div gdColumn="-1 / -2" fxLayout fxLayoutAlign="end center">
		<button mat-stroked-button color="warn" (click)="clearFilters()">
			<mat-icon svgIcon="clear_filters"></mat-icon>
			Clear Filters
		</button>
	</div>
</div>
